const threeColumnContent = {
  displayField: 'header',
  name: 'Three Column Content',
  description: '',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'contentCard',
      name: 'Content Card ',
      type: 'Array',
      localized: false,
      required: true,
      validations: [
        { size: { min: null, max: 6 }, message: 'Maximum of 6 Items' }
      ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [
          {
            linkContentType: [ 'contentCard' ],
            message: 'Please only use Content Card Type'
          }
        ],
        linkType: 'Entry'
      }
    }
  ],
  sys: {
    id: 'threeColumnContent',
    version: 22,
    updatedAt: '2023-08-03T14:40:41.264Z'
  }
};
export default threeColumnContent;